<template lang="html">
  <div>

    <c-confirm-dialog v-model="dialogConfirmaExclusao" @yes="excluirArquivo()" titulo="Deseja realmente excluir o arquivo?">
      "{{this.descricaoArquivoExclusao}}" será excluído após clicar na opção "Sim".
    </c-confirm-dialog>

    <v-data-table
    :headers="headers"
    :items="listaArquivos"
    :search="search"
    :no-data-text="'Este projeto não possui arquivos.'"
    must-sort
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
    :items-per-page="itemsPerPage"
    :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
    >
      <template v-slot:item.nome="props">
        <a :href="api_url + '/projetos/' + idProjeto + '/arquivos/' + props.item.idArquivo">
          <v-icon>vertical_align_bottom</v-icon>{{ props.item.nome.trim() }}
        </a>
      </template>
      <template v-slot:item.dtInclusao="props">{{dates.format(props.item.dtInclusao)}}</template>
      <template v-slot:item.opcoes="props">
        <div v-if="administrador === true || (projeto.funcao != null && projeto.funcao.item === 1) || projeto.assessor === true">
          <v-btn style="margin: 1px;" color="primary" text icon @click="editarArquivo(idProjeto, props.item.idArquivo)" ><v-icon>edit</v-icon></v-btn>
          <!-- no caso do delete, apenas o administrador pode deletar um arquivo -->
          <v-btn v-if="administrador === true" style="margin: 1px;" color="primary" text icon @click="botaoExcluirArquivo(props.item.idArquivo, props.item.nome.trim())" ><v-icon>delete</v-icon></v-btn>
        </div>
      </template>
      <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
        Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaArquivos.length }} arquivos
      </template>
    </v-data-table>
    <br><br>

    <c-card-footer
      :projeto="this.projeto"
      :extensao="this.extensao"
      proxima="ContatosProjeto"
      editar="UploadArquivo"
      nome_editar="Adicionar"
      :habilitaBotaoGerarPDFAcao=true
      :habilitaBotaoFinalizarAcao=true
    >
    </c-card-footer>

  </div>
</template>

<script>
import ConfirmDialog from '@/components/c-confirm-dialog'
import CardFooter from '@/components/c-card-footer'
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import dates from '@/utils/dates'
import projetos from '@/utils/projetos'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['idProjeto', 'projeto', 'extensao'],
  data: () => ({
    dialogConfirmaExclusao: false,
    idArquivoExclusao: 0,
    descricaoArquivoExclusao: '',
    api_url: process.env.API_BASE_URL,
    listaArquivos: [],
    dates: dates,
    search: null,
    sortBy: 'dtInclusao',
    sortDesc: false,
    itemsPerPage: 25,
    opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
    headers: [
      { text: 'Nome', align: 'left', value: 'nome' },
      { text: 'Tipo', align: 'left', value: 'tipoArquivo.descricao' },
      { text: 'Data de inclusão', align: 'left', value: 'dtInclusao' },
      { text: 'Observação', align: 'left', value: 'observacao' },
      { text: 'Opções', align: 'left', value: 'opcoes' }
    ]
  }),
  computed: {
    ...mapGetters('auth', ['administrador', 'usuarioPROEX'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
    truncate (string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...'
      else return string
    },
    carregarArquivos: function () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando arquivos.' })
      projetos.getArquivosDoProjeto(this.idProjeto)
      .then(response => {
        this.listaArquivos = response.data.slice()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando arquivos.' })
      })
    },
    botaoExcluirArquivo: function (idArquivo, descricao) {
      this.idArquivoExclusao = idArquivo
      this.descricaoArquivoExclusao = descricao
      this.dialogConfirmaExclusao = true
    },
    excluirArquivo: function () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo arquivo.' })
      projetos.deleteArquivo(this.idProjeto, this.idArquivoExclusao)
      .then(response => {
        this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
        this.carregarArquivos()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
        this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo arquivo.' })
      })
    },
    editarArquivo: function (idProjeto, idArquivo) {
      this.$router.push({ name: 'EditarArquivo', params: {idProjeto: idProjeto, idArquivo: idArquivo} })
    }
  },
  mounted () {
    this.carregarArquivos()
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'c-card-footer': CardFooter,
    'c-confirm-dialog': ConfirmDialog
  }
}
</script>

<style lang="css" slot-scoped>
</style>



// WEBPACK FOOTER //
// projeto-arquivos-tabela.vue?b2c34c26